(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  document.addEventListener('DOMContentLoaded', () => {
    const isDesktop = () => window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    const closeDelay = 200; // milliseconds

    /* ========== HEADER DROPDOWN MENUS ========== */
    const headerMenus = document.querySelectorAll('header details');

    headerMenus.forEach(details => {
      const summary = details.querySelector('summary');
      const submenu = details.querySelector('ul, .header__submenu');
      if (!summary || !submenu) return;

      let closeTimeout;

      details.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimeout);
        details.setAttribute('open', '');
        summary.setAttribute('aria-expanded', 'true');
      });

      details.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeTimeout = setTimeout(() => {
          details.removeAttribute('open');
          summary.setAttribute('aria-expanded', 'false');
        }, closeDelay);
      });

      summary.addEventListener('click', (e) => {
        if (isDesktop()) e.preventDefault();
      });
    });

    /* ========== CURRENCY SELECTOR (DISCLOSURE) ========== */
    const disclosures = document.querySelectorAll('.disclosure');

    disclosures.forEach(disclosure => {
      const button = disclosure.querySelector('.disclosure__button');
      const listWrapper = disclosure.querySelector('.disclosure__list-wrapper');
      const overlay = disclosure.querySelector('.country-selector__overlay');
      if (!button || !listWrapper) return;

      let closeTimeout;

      // Open on hover (desktop only)
      disclosure.addEventListener('mouseenter', () => {
        if (!isDesktop()) return;
        clearTimeout(closeTimeout);
        button.setAttribute('aria-expanded', 'true');
        disclosure.classList.add('is-open');
        listWrapper.style.display = 'block';
        if (overlay) overlay.style.display = 'block';
      });

      // Close on mouse leave (with delay)
      disclosure.addEventListener('mouseleave', () => {
        if (!isDesktop()) return;
        closeTimeout = setTimeout(() => {
          button.setAttribute('aria-expanded', 'false');
          disclosure.classList.remove('is-open');
          listWrapper.style.display = 'none';
          if (overlay) overlay.style.display = 'none';
        }, closeDelay);
      });

      // Prevent click toggling on desktop
      button.addEventListener('click', (e) => {
        if (isDesktop()) e.preventDefault();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
